export function unreachable(_case: never) {
  throw new Error(`invalid case ${_case}`);
}
